module.exports = __webpack_public_path__ + "img/feixinjiaju10.20f9233b.jpg";